<template>
    <Dashboard v-if="loaded" :stats="stats" @downloadFile="downloadFile" />
</template>

<script>
import { mapActions } from "vuex";
import Dashboard from "./_components/Dashboard";
import api from "src/services/api.js";
import { store, mutations } from "src/global-store.js";

export default {
    name: "DashboardModule",
    components: {
        Dashboard,
    },
    data() {
        return {
            dashboard: {
                unpaid_invoices_count: 0,
                receiptlogs_count: 0,
                preorders_count: 0,
            },
            loaded: false,
        };
    },
    computed: {
        me() {
            return store.me;
        },
        stats() {
            return [
                {
                    title: String(this.dashboard.unpaid_invoices_count),
                    subTitle: "Unpaid Invoices",
                    type: "danger",
                    icon: "fa fa-file-invoice-dollar",
                    link: "/invoices",
                },
                {
                    title: String(this.dashboard.receiptlogs_count),
                    subTitle: "Receipt Logs",
                    type: "info",
                    icon: "fa fa-receipt",
                    link: "/receipts",
                },
                {
                    title: String(this.dashboard.preorders_count),
                    subTitle: "Pre-Orders",
                    type: "warning",
                    icon: "fa fa-business-time",
                    link: "/preorders",
                },
            ];
        },
    },
    async created() {
        mutations.setNavbarTitle("Dashboard");
        try {
            this.dashboard = await api.get("/dashboard-stats");
        } catch (error) {
            console.error(error);
        }
        mutations.setNavbarSubtitle(
            this.me.customer_name || this.me.designer_name,
        );
        this.loaded = true;
    },
    methods: {
        ...mapActions(["downloadFile"]),
    },
};
</script>
